export default {
    //ChangeSubscriptionComponent
    info_promotional_coupon: 'Tens un cupó promocional? Fes clic a "Activar" per utilitzar-lo. ',

    //CurrentSubscriptionComponent
    canceled_message: 'El vostre compte ha estat cancel·lat. Subscriviu-vos a un pla per tornar a activar el vostre compte.',

    //StripeNumberComponent
    change_pay_method: 'Canviar mètode de pagament',

    //NavigationMyAccountComponent e InformationComponent
    subtitle: 'Gestiona el teu perfil, la facturació i la subscripció de la teva acadèmia.',
    sections: 'Seccions del meu compte',
    profile_description: 'Dades personals, foto i contrasenya',
    billing_details: 'Dades de facturació',
    billing_details_description: 'Dades fiscals i compte bancari',
    my_subscription: 'La meva subscripció',
    my_subscription_description: 'Pla actual i factures',
    plans_description: "Canvia de pla o reactiva'l",
    my_academies: 'Les meves acadèmies',
    my_academies_description: 'Acadèmies del teu compte',
    about: 'Quant a',
    about_description: 'Versió i novetats',
    about_title: "Informació de l'aplicació",
    app_name: 'Aplicació',
    manufacturer: 'Fabricant',
    version: 'Versió',
    changelog: 'Novetats',
    current_version: 'Versió actual',
    show_less: 'Veure menys',
    show_full_history: "Veure l'historial complet ({count} més)",
    thanks: 'Gràcies per confiar en BrainsPro. Continuem millorant la plataforma i aquí pots consultar les novetats a mesura que les publiquem.',
}
